import styled from 'styled-components';
import { isFocused } from '@belong/themes';
import { ButtonUnstyled } from '../../actions';
import { TextInput } from '../TextInput/TextInput';

export const Wrapper = styled.div`
  position: relative;
`;

export const VisibilityToggleWrapper = styled(ButtonUnstyled)`
  padding: 1rem;
  margin-left: 0.8rem;
  line-height: 0;
  position: absolute;
  top: 50%;
  right: 0.2rem;
  transform: translate3d(0, -50%, 0);
  cursor: pointer;

  &:focus {
    ${() => isFocused(true)}
  }
`;

export const Password = styled(TextInput)`
  padding-right: 5.4rem;
`;
